import React from 'react'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import './UspsImageCards.css'

export default function UspsImageCards({ section, index, className = '' }) {
  const { usps, textCard } = section
  const heading = textCard?.subheading || textCard?.heading?.text
  const alignText = textCard?.alignText || 'left'

  return (
    <section id={section.fieldGroupName + index} className={`mb-20 md:mb-24 mt-10 md:mt-16 ${className}`}>
      <div className="container">
        {heading && (
          <h2 className="usps-image-cards__heading" style={{ textAlign: alignText }}>{heading}</h2>
        )}
        <div className={`usps-image-cards__grid ${usps.length === 3 ? 'usps-image-cards__grid--3' : ''}`}>
          {usps.map((usp, i) => (
            <FadeInWhenVisible key={i} transition={{ delay: `${i * 0.05}` }}>
              <div className="usp-image-card__item">
                {usp.image && (
                  <div className="usp-image-card__image-wrapper">
                    <Image
                      data={usp.image}
                      className="usp-image-card__image"
                      objectFit="cover"
                    />
                  </div>
                )}
                {usp.heading && (
                  <h5 className="usp-image-card__title">{usp.heading}</h5>
                )}
                {usp.content && (
                  <p className="usp-image-card__content">{usp.content}</p>
                )}
                {usp.link?.url && (
                  <a href={usp.link.url} className="usp-image-card__link">
                    <span>{usp.link.title || 'Learn More'}</span>
                    <div className="usp-image-card__link-divider" />
                  </a>
                )}
              </div>
            </FadeInWhenVisible>
          ))}
        </div>
      </div>
    </section>
  )
}
